"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericElement = exports.GenericElementOption = void 0;
var GenericElementOption = /** @class */ (function () {
    function GenericElementOption(
    /**
     * Name of the option
     */
    name, 
    /**
     * Value of the option
     */
    codename) {
        this.name = name;
        this.codename = codename;
    }
    return GenericElementOption;
}());
exports.GenericElementOption = GenericElementOption;
var GenericElement = /** @class */ (function () {
    function GenericElement(data) {
        /**
         * Array of options if the element has some
         */
        this.options = [];
        Object.assign(this, data);
    }
    return GenericElement;
}());
exports.GenericElement = GenericElement;
//# sourceMappingURL=element-models.js.map